export const OPEN = "messageDialog/OPEN";
export const CLOSE = "messageDialog/CLOSE";

export const openMessageDialog = message => ({
  type: OPEN,
  message
});

export const closeMessageDialog = () => ({
  type: CLOSE
});

const initialState = {
  open: false,
  message: {}
};

const messageDialog = (state = initialState, action) => {
  switch (action.type) {
    case OPEN:
      return {
        open: true,
        message: action.message
      };
    case CLOSE:
      return { ...state, open: false };
    default:
      return state;
  }
};

export default messageDialog;



// WEBPACK FOOTER //
// ./src/redux/modules/messageDialog.js